import React, { useEffect } from 'react';
import { Radio, Box, Checkbox, Typography } from '@mui/material';
import { TaskBallColor } from '../../../../commands/practitioner/enums/TaskBallColor';
import useAppContext from '../../../../hooks/useAppContext/useAppContext';
import usePractitionerControlsContext from '../../../../hooks/usePractitionerControlsContext/usePractitionerControlsContext';
import BackendService from '../../../../services/BackendService';
import { generateColorString } from '../../../../utils/serializer';
import TaskScene from '../../../PhaserApp/components/application/scene/TaskScene';
import { colourDetailsStyles } from './style';
import useCurrentSessionState from '../../../../hooks/useCurrentSessionState/useCurrentSessionState';
import { legacyDefaultColors } from '../../../../commands/practitioner/ballColors/BallColors';

interface colourDetailsLegacyProps {
  autoColour: number;
  setColorOption: any;
  shouldTriggerEffect: boolean;
  title: string;
}

export function ColourDetailsLegacy(props: colourDetailsLegacyProps) {
  const { shouldTriggerEffect, autoColour, setColorOption, title } = props;
  const { sessionId, treatmentId } = useAppContext();
  const { game, selectedColor, setSelectedColor } = usePractitionerControlsContext();
  const { colourDetails } = colourDetailsStyles;
  const currentState = useCurrentSessionState() || {};
  const toId = (value: string) => value.toLowerCase().replace(/[^a-z0-9]+/g, '');

  useEffect(() => {
    if (!shouldTriggerEffect) return;
    const variablesInCommand = '0,' + selectedColor;
    const finalCommand = generateColorString(variablesInCommand);
    BackendService.sendManualColorCommand(sessionId, treatmentId, variablesInCommand);
    const therapist = game?.scene.keys.therapist as TaskScene;
    therapist.updateTaskBasedOnEncodedCommand(finalCommand);
  }, [shouldTriggerEffect, selectedColor]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let currentColour = (event.target.value as unknown) as TaskBallColor;
    setSelectedColor(currentColour);
  };

  const controlProps = (item: TaskBallColor) => ({
    checked: selectedColor === item,
    onChange: handleChange,
    value: item,
    name: 'color-radio-button-demo',
    inputProps: { 'aria-label': item.toString() },
  });

  const autoColorHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setColorOption(event.target.checked ? 1 : 0);
  };

  return (
    <Box sx={colourDetails}>
      <Box className="subtitle-container">
        <Checkbox checked={autoColour === 1} onChange={autoColorHandler} data-testid="pwid-color-auto-toggle" />
        <Typography className="subtitle-text">{title}</Typography>
      </Box>
      <Box className="colors-container">
        {legacyDefaultColors.map(settings => {
          return (
            <Radio
              disabled={autoColour === 1}
              className="balls"
              {...controlProps(settings.value)}
              key={settings.label}
              data-testid={`pwid-color-${toId(settings.label)}`}
              sx={{
                color: settings.label,
                '& .MuiSvgIcon-root': {
                  borderRadius: '50%',
                  backgroundColor: settings.label,
                },
                '&.Mui-checked': {
                  color: 'transparent',
                },
                '&.Mui-disabled': {
                  '& .MuiSvgIcon-root': {
                    opacity: 0.5,
                  },

                  color: 'transparent',
                },
                '&:hover': {
                  backgroundColor: settings.label,
                  opacity: 0.8,
                  '& .MuiSvgIcon-root': {
                    backgroundColor: settings.label,
                    opacity: 0.8,
                  },
                },
              }}
            />
          );
        })}
      </Box>
    </Box>
  );
}
